import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {ToggleSwitch} from "primeng/toggleswitch";
import {FormsModule} from "@angular/forms";
import {Divider} from "primeng/divider";

export type NotificationCategoryChange = {
  readonly category: 'lottery' | 'lotteryfollowup' | 'promotional';
  readonly enabled: boolean;
};

@Component({
  selector: 'homey-notification-category-toggles',
  standalone: true,
  imports: [ToggleSwitch, FormsModule, Divider],
  templateUrl: './notification-category-toggles.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationCategoryTogglesComponent {
  readonly lotteryEnabled = input(true);
  readonly lotteryFollowupEnabled = input(true);
  readonly promotionalEnabled = input(false);
  readonly disabled = input(false);

  readonly categoryChange = output<NotificationCategoryChange>();

  protected onLotteryChange(enabled: boolean) {
    this.categoryChange.emit({category: 'lottery', enabled});
  }

  protected onLotteryFollowupChange(enabled: boolean) {
    this.categoryChange.emit({category: 'lotteryfollowup', enabled});
  }

  protected onPromotionalChange(enabled: boolean) {
    this.categoryChange.emit({category: 'promotional', enabled});
  }
}
